import { z } from "zod"

const REASON_MAX_LENGTH = 100

const manageDuplicatesSchema = z.object({
  patientIds: z.array(z.string()).min(2, { message: "patient.duplicates.errors.minimumPatients" }),
  primaryPatientId: z.string().min(1, { message: "common.fieldErrorList.requiredField" }),
  reason: z.string().max(REASON_MAX_LENGTH, { message: "common.fieldErrorList.characterLimit" }),
  confirmed: z.boolean().refine((val) => val === true, {
    message: "common.fieldErrorList.requiredField",
  }),
})

type ManageDuplicatesForm = z.infer<typeof manageDuplicatesSchema>

export { manageDuplicatesSchema, REASON_MAX_LENGTH, type ManageDuplicatesForm }
